import { combineReducers } from "redux";
import { connectRouter } from "connected-react-router";

import app from "./app/reducer";
import loading from "./loading/reducer";
import report from "./report/reducer";

const rootReducer = (history) =>
  combineReducers({
    router: connectRouter(history),
    app,
    loading,
    report,
  });

export default rootReducer;
